const state = {
  goodsForeNo: '',
  // 左侧菜单配置
  menuConfig: null
}
const mutations = {
  STORE_GOODSFORENO (state, params) {
    state.goodsForeNo = params
  },
  // 存储菜单配置
  STORE_MENU_CONFIG (state, menu) {
    state.menuConfig = menu
  }
}
export default {
  namespaced: true,
  state,
  // getters,
  // actions,
  mutations
}
